import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./login.css";
import { connect } from "react-redux";
import { loginJWT, signupJWT } from "../redux/authJWT/action";
import { serverResponse } from "../util/fakeServer";
import { useLocation } from "react-router-dom";
import LoadingPages from "./Loading.pages";
import { requestPasswordResetApi } from "../services/api.services";
import { language } from "../languageProvider/language/language";
import { defaultLanguage, hasNewCheckout } from "../helper/utility";
import { interattivoLogo } from "../helper/constant";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { startLoadingJWT, endLoadingJWT } from "../redux/authJWT/action";
import PasswordInput from "../components/common/PasswordInput";
import PasswordCriteria from "../components/common/PasswordCriteria";
import { isPasswordValid } from "../util/passwordValidation";
import InPublishIcona from "../assets/images/icone/InPublish.icona";

function Form(props) {
  const { passwordProtected } = serverResponse.config;
  const [option, setOption] = useState(1);
  const location = useLocation();
  const navigate = useNavigate();

  const [errorReset, setErrorReset] = useState(null);
  const [feedMessage, setFeedMessage] = useState(false);
  const [validationError, setValidationError] = useState(null);
  // Logo cliente assente o non caricabile -> fallback al logo InPublish (footer)
  const [logoError, setLogoError] = useState(!serverResponse.config.logo_full);
  const [form, setForm] = useState({
    email: passwordProtected ? "volantino@interattivo.it" : "",
    password: "",
    confirm_password: "",
    name: "",
    surname: "",
    codice: "",
    privacy: false,
  });

  useEffect(() => {
    switch (location.pathname) {
      case "/register":
        setOption(2);
        break;
      case "/reset-psw":
        setOption(3);
        break;
      default:
        setOption(1);
    }
  }, [location.pathname]);

  const refEmail = useRef(null);
  const refName = useRef(null);
  const refSurname = useRef(null);

  const onChange = ({ name, value }) => {
    setForm({ ...form, [name]: value });
    setValidationError(null);
  };

  const resetAll = () => {
    setErrorReset(null);
    setFeedMessage(null);
    setValidationError(null);
  };

  const handleOnPress = () => {
    setErrorReset(null);
    setValidationError(null);

    if (!feedMessage) {
      if (option === 1) {
        props.loginJWT(form, navigate);
      }
      if (option === 2) {
        if (!isPasswordValid(form.password)) {
          setValidationError(language[defaultLanguage].password_min_length);
          return;
        }
        if (form.password !== form.confirm_password) {
          setValidationError(language[defaultLanguage].password_non_corrispondono);
          return;
        }
        if (!form.privacy) {
          setValidationError(language[defaultLanguage].privacy_obbligatoria);
          return;
        }
        props.signupJWT(form);
      }
      if (option === 3) {
        const resetUrl = `${window.location.href.replace("reset-psw", "")}set-psw`;
        props.startLoadingJWT();
        requestPasswordResetApi(form.email, resetUrl, window.location.origin)
          .then((res) => {
            if (res.status === 200) {
              setFeedMessage(language[defaultLanguage].email_successo);
            } else if (res.status === 403) {
              setErrorReset(language[defaultLanguage].email_non_presente);
            } else {
              setErrorReset(language[defaultLanguage].errore_invio_mail);
            }
          })
          .catch((err) => {
            setErrorReset(language[defaultLanguage].errore_invio_mail);
          })
          .finally(() => props.endLoadingJWT());
      }
    }
  };

  if (
    !serverResponse.config.allow_login ||
    (props.authJWT.isAuthenticated && !props.authJWT.loadingProfile)
  ) {
    if (location.state && location.state.referrer)
      return navigate(location.state.referrer);
    else return navigate("/leaflet");
  }

  if (props.authJWT.loadingProfile) {
    return <LoadingPages />;
  }

  return (
    <div className="auth-page">
      <div className="auth-page__content">
        {logoError ? (
          <div className="auth-page__logo auth-page__logo--fallback">
            <InPublishIcona />
          </div>
        ) : (
          <img
            className="auth-page__logo"
            src={serverResponse.config.logo_full}
            alt="logo cliente"
            onError={() => setLogoError(true)}
          />
        )}
        <header>
          <div
            className={
              "header-headings " +
              (option === 1 ? "sign-in" : option === 2 ? "sign-up" : "forgot")
            }
          >
            <span>{language[defaultLanguage].effettua_login}</span>
            <span>{language[defaultLanguage].crea_account}</span>
            <span>{language[defaultLanguage].resetta_psw}</span>
          </div>
        </header>

        {!props.authJWT.success_signup && (
          <ul className="options" style={{ listStyle: "none", padding: 0 }}>
            <li
              className={option === 1 ? "active" : ""}
              onClick={() => { resetAll(); setOption(1); navigate("/login"); }}
            >
              {language[defaultLanguage].login}
            </li>
            {!passwordProtected && (
              <li
                className={option === 2 ? "active" : ""}
                onClick={() => { resetAll(); setOption(2); navigate("/register"); }}
              >
                {language[defaultLanguage].registrati}
              </li>
            )}
            {/* Recupero password: solo stack v2 (endpoint non esiste sul
                backend legacy) -> nascosto ai tenant senza x_client_token. */}
            {!passwordProtected && hasNewCheckout() && (
              <li
                className={option === 3 ? "active" : ""}
                onClick={() => { resetAll(); setOption(3); navigate("/reset-psw"); }}
              >
                {language[defaultLanguage].rec_psw}
              </li>
            )}
          </ul>
        )}

        {!props.success_signup && (
          <form
            className="auth-form"
            onSubmit={(evt) => { evt.preventDefault(); handleOnPress(); }}
          >
            {!props.authJWT.success_signup && (
              <div className="auth-form__fields">
                {/* Nome + Cognome (solo registrazione) */}
                {!passwordProtected && option === 2 && (
                  <div className="auth-form__row">
                    <input
                      minLength={2}
                      value={form.name}
                      ref={refName}
                      name="name"
                      id="name"
                      type="text"
                      className="auth-form__input"
                      placeholder={`${language[defaultLanguage].nome}*`}
                      required
                      onChange={(e) => onChange({ name: "name", value: e.target.value })}
                    />
                    <input
                      minLength={2}
                      ref={refSurname}
                      value={form.surname}
                      id="surname"
                      name="surname"
                      type="text"
                      className="auth-form__input"
                      placeholder={`${language[defaultLanguage].cognome}*`}
                      required
                      onChange={(e) => onChange({ name: "surname", value: e.target.value })}
                    />
                  </div>
                )}

                {/* Email */}
                {!passwordProtected && (
                  <input
                    value={form.email}
                    ref={refEmail}
                    id="email"
                    name="email"
                    type="email"
                    className="auth-form__input"
                    placeholder={`${language[defaultLanguage].email}*`}
                    required
                    onChange={(e) => onChange({ name: "email", value: e.target.value })}
                  />
                )}

                {/* Password (solo login e registrazione) */}
                {(option === 1 || option === 2) && (
                  <PasswordInput
                    value={form.password}
                    id="password"
                    name="password"
                    placeholder={`${language[defaultLanguage].password}*`}
                    required
                    onChange={(e) => onChange({ name: "password", value: e.target.value })}
                  />
                )}

                {/* Criteri password (solo registrazione) */}
                {option === 2 && (
                  <PasswordCriteria password={form.password} />
                )}

                {/* Conferma password (solo registrazione) */}
                {!passwordProtected && option === 2 && (
                  <PasswordInput
                    value={form.confirm_password}
                    id="confirm_password"
                    name="confirm_password"
                    placeholder={`${language[defaultLanguage].conferma_password}*`}
                    required
                    onChange={(e) => onChange({ name: "confirm_password", value: e.target.value })}
                  />
                )}

                {/* Codice cliente / carta fedeltà (solo registrazione) */}
                {!passwordProtected && option === 2 && (
                  <input
                    value={form.codice}
                    id="codice"
                    name="codice"
                    type="text"
                    className="auth-form__input"
                    placeholder={`${language[defaultLanguage].codice_cliente || "Codice cliente"}`}
                    onChange={(e) => onChange({ name: "codice", value: e.target.value })}
                  />
                )}

                {/* Privacy (solo registrazione) */}
                {!passwordProtected && option === 2 && (
                  <label className="auth-form__privacy">
                    <input
                      type="checkbox"
                      checked={form.privacy}
                      onChange={(e) => onChange({ name: "privacy", value: e.target.checked })}
                    />
                    {language[defaultLanguage].accetto_privacy}
                  </label>
                )}
              </div>
            )}

            {validationError && (
              <div className="auth-form__error">{validationError}</div>
            )}

            {!feedMessage && !props.authJWT.feedbackMessage && (
              <button className="auth-form__submit" type="submit">
                {option === 1
                  ? language[defaultLanguage].login
                  : option === 2
                  ? language[defaultLanguage].registrati
                  : language[defaultLanguage].resetta_psw}
                {props.authJWT.loading && (
                  <div className="spinner-border spinner-border-sm ms-2" role="status">
                    <span className="sr-only">Loading...</span>
                  </div>
                )}
              </button>
            )}

            {!!props.authJWT.error && (
              <div className="auth-form__error">{props.authJWT.error}</div>
            )}

            {!!errorReset && (
              <div className="auth-form__error">{errorReset}</div>
            )}

            {feedMessage && (
              <p className="auth-form__feedback">
                {feedMessage}
                <FontAwesomeIcon style={{ color: "green", marginLeft: "5px" }} icon={faCheck} />
              </p>
            )}
            {props.authJWT.feedbackMessage && (
              <p className="auth-form__feedback">
                {props.authJWT.feedbackMessage}
                <FontAwesomeIcon style={{ color: "green", marginLeft: "5px" }} icon={faCheck} />
              </p>
            )}
          </form>
        )}

        {/* Back button - sotto il form */}
        {!serverResponse.config.only_logged && (
          <div
            className="auth-page__back"
            onClick={() => navigate("/leaflet")}
          >
            <FontAwesomeIcon icon={faArrowLeft} />
            <span>{language[defaultLanguage].torna_al_volantino}</span>
          </div>
        )}
      </div>

      <div className="auth-page__footer">
        {serverResponse.config.type === "inpublish" ? (
          <div className="auth-page__footer-icon">
            <InPublishIcona />
          </div>
        ) : (
          <>
            <span style={{ fontSize: "0.7em", marginRight: "5px" }}>powered by</span>
            <img
              style={{ width: "200px" }}
              className="img-fluid"
              src={interattivoLogo}
              alt="logo creator"
            />
          </>
        )}
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
  authJWT: state.authJWT,
});

export default connect(mapStateToProps, {
  loginJWT,
  signupJWT,
  startLoadingJWT,
  endLoadingJWT,
})(Form);
